import { normalize, schema } from 'normalizr';
import { IState, ActionTypes } from './type';

const domainSchema = new schema.Entity('domains');
const domainListSchema = [domainSchema];

const initial: IState = {
  entities: {},
  ids: [],
  count: 0,
  loading: false,
};

const reducer = (state: IState = initial, action: any) => {
  switch (action.type) {
    case ActionTypes.REQUEST:
      return {
        ...state,
        loading: true
      };

    case ActionTypes.SUCCESS: {
      const normalizedData = normalize(action.payload.results, domainListSchema);

      return {
        ...state,
        entities: {
          ...state.entities,
          ...normalizedData.entities.domains,
        },
        ids: normalizedData.result as string[],
        count: action.payload.count as number,
        loading: false
      };
    }

    case ActionTypes.SUCCESS_SINGLE: {
      const domain = action.payload;
    
      return {
        ...state,
        entities: {
          ...state.entities,
          [domain.id]: domain
        },
        loading: false
      };
    }

    case ActionTypes.UPDATE_SUCCESS: {
      const domain = action.payload;
    
      return {
        ...state,
        entities: {
          ...state.entities,
          [domain.id]: domain
        },
        loading: false
      };
    }

    case ActionTypes.DELETE_SUCCESS: {
      const { id } = action.payload;
    
      const { [id]: deletedItem, ...remainingEntities } = state.entities;
    
      return {
        ...state,
        entities: remainingEntities,
        ids: state.ids.filter(existingId => existingId !== id),
        loading: false
      };
    }

    case ActionTypes.FAILURE:
      return {
        ...state,
        loading: false
      };

    default:
      return state;
  }
}

export default reducer;
